import { http } from '@/app/lib/http/client'

// 1. Interfaz Principal (Como viene de la base de datos/API)
export interface SucursalItem {
    id: number
    name: string
    address: string
    manager: string
}

// 2. Interfaz para Crear (Lo que mandas en el POST)
export interface SucursalGoalPayload {
    dailyGoal: number
    monthlyGoal: number
    annualGoal: number
    sucursal_id: number
}

// 3. El Objeto de Servicio con todas las peticiones
export const multibranchService = {
    // Obtener todos (con paginación/búsqueda opcional)
    async getMetrics() {
        const response = await http.get('/multibranch/dashboard')
        console.log(response.data.data)
        return response.data.data
    },

    // Obtener uno solo por ID
    async getSucursal(id: string) {
        const response = await http.get(`/sucursales/${id}`)
        return response.data
    },

    // Actualizar metas en bloque
    async updateGoals(goals: any[]) {
        const response = await http.post('/multibranch/dashboard/goals', { goals })
        return response.data
    },

}
